
export const convertLanguage = {"hib":"hi","de":"de","ru":"ru","fi":"fi","pt":"pt","bg":"bg","fr":"fr","zh-CN":"zh-CN","vib":"vi","itb":"it","elb":"el","sv":"sv","ko":"ko","zh-TW":"zh-TW","slb":"sl","en":"en","thb":"th","et":"et","cs":"cs","ar":"ar","hub":"hu","esb":"es","ja":"ja","pl":"pl","ro":"ro","da":"da","nl":"nl"}

export const getReplaceByString = (string: string, replaceStr: string) => {
    const oldString = string
    // @ts-ignore
    const newString = oldString.replace(replaceStr, "")
    return newString;
};

export const formatDate = (time: string, type: string = 'YY-MM-DD', add: boolean = true) => {
    let timestamp = 0;
    if (typeof time === 'string') {
        time = time.replace('T', ' ').replace('.000+0000', '')
        const date = new Date(time);
        timestamp = date.getTime()
        // 转换成北京时间，utc时间+8h
        if (add) {
            timestamp = timestamp / 1000
            timestamp = timestamp + 60 * 60 * 8
            timestamp = timestamp * 1000
        }
    } else {
        if (typeof time === 'number'){
            timestamp = time;
        } else if (!time) {
            timestamp = new Date().valueOf();
        } else if (typeof time === 'object') {
            timestamp = time.getTime();
        }
    }

    let dateStr = '';
    var beijingDate = new Date(timestamp)
    let YY = beijingDate.getFullYear(),
        MM: string | number = beijingDate.getMonth() + 1,
        DD: string | number = beijingDate.getDate(),
        hh: string | number = beijingDate.getHours(),
        mm: string | number = beijingDate.getMinutes(),
        ss: string | number = beijingDate.getSeconds();
    MM = MM < 10 ? ("0" + MM) : MM;
    DD = DD < 10 ? ("0" + DD) : DD;
    hh = hh < 10 ? ("0" + hh) : hh;
    mm = mm < 10 ? ("0" + mm) : mm;
    ss = ss < 10 ? ("0" + ss) : ss;

    switch (type) {
        case 'MM-DD hh:mm':
            dateStr = MM + '-' + DD + ' ' + hh + ':' + mm;
            break;
        case 'MM-DD':
            dateStr = MM + '-' + DD;
            break;
        case 'hh:mm':
            dateStr = hh + ':' + mm;
            break;
        case 'YY-MM-DD':
            dateStr = YY + '-' + MM + '-' + DD
            break;
        case 'MM-DD hh:mm:ss':
            dateStr = MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
            break;
        case 'YYMMDD':
            dateStr = YY + '' + MM + '' + DD;
            break;
        case 'YY':
            dateStr = YY + '';
            break;
        case 'YY-MM':
            dateStr = YY + '-' + MM;
            break;
        default:
            dateStr = YY + '-' + MM + '-' + DD + ' ' + hh + ':' + mm + ':' + ss;
    }
    return dateStr;
};


// 格式化数字 3位一个逗号
export const formatNumber = (value: number | string) => {
    if(typeof value === 'string'){
       return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// 获取静态资源
export const getStaticResource = (path: string) => {
    return new URL(`@/assets/images/${path}`, import.meta.url).href
}   

export function findKey (obj,value, compare = (a, b) => a === b) {
    return Object.keys(obj).find(k => compare(obj[k], value))
}

export function containsSubstring(str: string, substring: string) {
    // 使用正则表达式创建一个RegExp对象
    const regex = new RegExp(substring);
    // 使用test方法检查是否匹配
    return regex.test(str);
}